<div class="tabs">
    <ul class="nav nav-tabs nav-width-equal">
        <li class="nav-item">
            <a class="nav-link"
                href="javascript:void(0)"
                data-test-id="quickflows-single-tab"
                [ngClass]="{ active: showSingleSecurityQuickflowsTab }"
                (click)="toggleQuickflowTab()"
            >Single</a>
        </li>
        <li class="nav-item">
            <a class="nav-link"
                href="javascript:void(0)"
                data-test-id="quickflows-comparison-tab"
                [ngClass]="{ active: !showSingleSecurityQuickflowsTab }"
                (click)="toggleQuickflowTab()"
            >Comparison</a>
        </li>
    </ul>
</div>
<ycn-single-select-quickflows class="tab-content"
    [hidden]="!showSingleSecurityQuickflowsTab"
    [displaySecurityId]="displaySecurityId"
    [securityId]="securityId"
    [securityName]="securityName"
    [securityUrl]="securityUrl"
></ycn-single-select-quickflows>
<ycn-multi-select-quickflows class="tab-content"
    [hidden]="showSingleSecurityQuickflowsTab"
    [displaySecurityId]="displaySecurityId"
    [securityId]="securityId"
    [securityName]="securityName"
    [securityUrl]="securityUrl"
></ycn-multi-select-quickflows>
